export class EmailVo {
    address?: string;
    domain?: string;
}